import { useEffect, useState } from "react";
import "./index.css";
import { NonCompanyComponent } from "../../components/ProductComponent";
import { Link } from "react-router-dom";
import { getServiceList } from "../../apis/Service";
import bigplus from "../../assets/shapes_svg/product/bigplus.svg";
import { useTranslation } from "react-i18next";

const AddService = () => {
  const { t } = useTranslation();
  return (
    <div className="addproductcomponent">
      <h3>{t("ADD_SERVICE")}</h3>
      <img src={bigplus} alt="" />
    </div>
  );
};

const Service = ({ chooseAlphabet, searchbar, chosenTab }) => {
  const [services, setServices] = useState([]);
  const [shared, setShared] = useState({});
  const { t } = useTranslation();

  useEffect(() => {
    // getBusinessList({setLocations: setLocations})
    getServiceList({ setProducts: setServices, setShared: setShared });
  }, []);

  return (
    <>
      <div className="product__bubble__title">
        <h6>{t("SERVICE")}</h6>
      </div>
      <div className="product__bubble" style={{ marginBottom: "30px" }}>
        {chosenTab === "normal"
          ? services.map((product, i) => {
              let showSearch = false;
              let showChooseAlphabet = false;
              if (
                searchbar !== "" &&
                product.name.toLowerCase().includes(searchbar)
              )
                showSearch = true;
              if (
                chooseAlphabet !== "" &&
                product.name.toUpperCase().startsWith(chooseAlphabet)
              )
                showChooseAlphabet = true;
              if (
                (showSearch && showChooseAlphabet) ||
                (showSearch && chooseAlphabet === "") ||
                (searchbar === "" && showChooseAlphabet)
              )
                return (
                  <Link
                    key={i}
                    className="nav-link"
                    to={"/service/" + product.id}
                  >
                    <NonCompanyComponent
                      created_at={product.created_at}
                      name={product.name}
                    />
                  </Link>
                );
              else if (searchbar === "" && chooseAlphabet === "")
                return (
                  <Link
                    key={i}
                    className="nav-link"
                    to={"/service/" + product.id}
                  >
                    <NonCompanyComponent
                      created_at={product.created_at}
                      name={product.name}
                    />
                  </Link>
                );
            })
          : (shared[chosenTab] ?? [])
              ?.filter((prod) => prod.is_product === false)
              ?.map((product, i) => {
                let showSearch = false;
                let showChooseAlphabet = false;
                if (
                  searchbar !== "" &&
                  product.name.toLowerCase().includes(searchbar)
                )
                  showSearch = true;
                if (
                  chooseAlphabet !== "" &&
                  product.name.toUpperCase().startsWith(chooseAlphabet)
                )
                  showChooseAlphabet = true;
                if (
                  (showSearch && showChooseAlphabet) ||
                  (showSearch && chooseAlphabet === "") ||
                  (searchbar === "" && showChooseAlphabet)
                )
                  return (
                    <Link
                      key={i}
                      className="nav-link"
                      to={"/service/" + product.id}
                    >
                      <NonCompanyComponent
                        created_at={product.created_at}
                        name={product.name}
                      />
                    </Link>
                  );
                else if (searchbar === "" && chooseAlphabet === "")
                  return (
                    <Link
                      key={i}
                      className="nav-link"
                      to={"/service/" + product.id}
                    >
                      <NonCompanyComponent
                        created_at={product.created_at}
                        name={product.name}
                      />
                    </Link>
                  );
              })}

        <Link className="nav-link" to={"/service/add"}>
          <AddService />
        </Link>
      </div>
    </>
  );
};

export default Service;
